import * as React from 'react';
import { ArrowRoundForwardIcon, Greyscale } from 'glints-aries';
import { Neutral } from 'glints-aries/lib/@next/utilities/colors';
import { FormattedMessage } from 'react-intl';

import { useEmployersURL } from 'src/common/hooks';
import { AssetType } from 'src/components/GlintsPicture/interfaces';

import { getTalentHubLandingLinks } from '../constants';
import * as Styled from './Hero.sc';

export const Hero: React.FC = () => {
  const talentHubLinks = getTalentHubLandingLinks(useEmployersURL());

  return (
    <Styled.HeroSection>
      <Styled.HeroInner>
        <Styled.HeroCopy>
          <FormattedMessage
            id="landing-global.hero.heading"
            defaultMessage="Build world-class teams <accent>globally</accent>"
            values={{
              accent: (...chunks: React.ReactNode[]) => (
                <Styled.HeadingAccent>{chunks}</Styled.HeadingAccent>
              ),
            }}
            tagName={Styled.Heading}
          />

          <FormattedMessage
            id="landing-global.hero.lede"
            defaultMessage="Post jobs for free or let Glints build and run your team anywhere in the world. Trusted globally by 55,000+ organizations."
            tagName={Styled.Lede}
          />

          <Styled.CTARow>
            <Styled.PrimaryCTA href={talentHubLinks.hire}>
              <FormattedMessage
                id="landing-sg.hero.cta.hire"
                defaultMessage="Start hiring"
                tagName="span"
              />
              <ArrowRoundForwardIcon color={Neutral.B18} />
            </Styled.PrimaryCTA>
            <Styled.SecondaryCTA href={talentHubLinks.singaporeJobs}>
              <FormattedMessage
                id="landing-sg.hero.cta.find-jobs"
                defaultMessage="Find a job"
                tagName="span"
              />
              <ArrowRoundForwardIcon color={Greyscale.white} />
            </Styled.SecondaryCTA>
            <Styled.SecondaryCTA href={talentHubLinks.aiAgents}>
              <FormattedMessage
                id="landing-global.hero.cta.ai-agents"
                defaultMessage="AI Agents"
                tagName="span"
              />
              <ArrowRoundForwardIcon color={Greyscale.white} />
            </Styled.SecondaryCTA>
          </Styled.CTARow>
        </Styled.HeroCopy>

        <Styled.HeroArt>
          <Styled.HeroImage
            name="hero-image.png"
            assetType={AssetType.dstLandingSgPage}
            lazy={false}
            fetchPriority="high"
            width={520}
            height={556}
            sizes="(max-width: 480px) 280px, (max-width: 768px) 380px, 520px"
            breakpoints={[280, 380, 520, 560, 760, 1040]}
            alt=""
          />
        </Styled.HeroArt>
      </Styled.HeroInner>
    </Styled.HeroSection>
  );
};

export default Hero;
